import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { AlertTriangle } from 'lucide-react';

/**
 * Custom confirmation dialog shown when user tries to navigate
 * away while a file download is in progress.
 *
 * Usage:
 *   const { blocked, proceedNavigation, cancelNavigation } = useDownload();
 *   <DownloadGuard blocked={blocked} onProceed={proceedNavigation} onCancel={cancelNavigation} />
 */
export default function DownloadGuard({ blocked, onProceed, onCancel }) {
  return (
    <Dialog open={blocked} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <DialogContent className="max-w-sm" data-testid="download-guard-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-9 h-9 rounded-full bg-amber-100">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
            </div>
            <DialogTitle className="text-base" data-testid="download-guard-title">Download in progress</DialogTitle>
          </div>
          <DialogDescription className="text-sm text-slate-500 mt-2">
            A file is still downloading. Leaving this page will cancel the download. Are you sure?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0 mt-2">
          <Button variant="outline" size="sm" onClick={onCancel} data-testid="download-guard-stay">
            Stay on page
          </Button>
          <Button variant="destructive" size="sm" onClick={onProceed} data-testid="download-guard-leave">
            Leave &amp; cancel download
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
